import Link from 'next/link';
import { TSmallHeaderWithText } from '@features/cms/typescript';
import styles from '@features/cms/components/pages/SmallHeaderWithText/SmallHeaderWithText.styles';
import Heading from '@components/Heading/Heading';
import Button from '@components/Button/Button';
import sanitizeHtml from '@utils/sanitizeHtml';
import scrollToElementById from '@utils/scrollToElementById';
import theme from '@styles/theme';
type PropsType = {
  data: TSmallHeaderWithText;
  defaultBackground?: string;
  isFirst?: boolean;
};
const SmallHeaderWithText = ({
  data,
  defaultBackground = theme.rawColors.neutralWhite,
  isFirst = false
}: PropsType) => {
  const {
    backgroundColor,
    title,
    description,
    buttonText,
    buttonLink,
    fontColor,
    code
  } = data;
  return <section id={code} sx={styles.headerWithText(backgroundColor || defaultBackground, fontColor)} data-testid={code}>
      <Heading h={isFirst ? 1 : 2} display={2} color={fontColor} pb={16} mobile>
        {title}
      </Heading>
      <p dangerouslySetInnerHTML={sanitizeHtml(description)} />
      {buttonLink && buttonText && <>
          {buttonLink.slice(0, 1) === '#' ? <Button onClick={() => scrollToElementById(buttonLink.substring(1))} variantColor="dark" size="small" letterCase="lowercase" cy={`${code}-button`} data-testid="small-header-with-text-button">
              {buttonText}
            </Button> : <Link href={buttonLink} data-testid="small-header-with-text-button-link">
              <Button variantColor="dark" size="small" letterCase="lowercase" cy={`${code}-button`} data-testid="small-header-with-text-button">
                {buttonText}
              </Button>
            </Link>}
        </>}
    </section>;
};
export default SmallHeaderWithText;